<script lang="ts">
	import { createEventDispatcher } from 'svelte';

	import { CAMERA_CLOUD_STORAGE_PLANS } from 'src/helpers/camera_cloud_storage_helpers';
	import type {
		CameraCloudStorageActivePlan,
		CameraCloudStoragePlanTier,
	} from 'src/types/CameraCloudStorage';

	import CameraCloudStoragePlanCard from './CameraCloudStoragePlanCard.svelte';

	export let activePlan: CameraCloudStorageActivePlan | null = null;
	export let loadingTier: CameraCloudStoragePlanTier | null = null;

	const dispatch = createEventDispatcher<{
		subscribe: { tier: CameraCloudStoragePlanTier };
		upgrade: { tier: CameraCloudStoragePlanTier };
	}>();
</script>

<div
	style="position: relative; display: grid; grid-template-columns: repeat(auto-fit, minmax(260px, 1fr)); grid-gap: var(--spacing-s); z-index: 0;"
>
	{#each CAMERA_CLOUD_STORAGE_PLANS as plan (plan.tier)}
		<CameraCloudStoragePlanCard
			{plan}
			{activePlan}
			loading={loadingTier === plan.tier}
			on:subscribe={() => dispatch('subscribe', { tier: plan.tier })}
			on:upgrade={() => dispatch('upgrade', { tier: plan.tier })}
		/>
	{/each}
</div>
